<template lang="pug">
  <el-dialog title="编辑订单组别" class="dialogClass" :visible.sync="dialogVisible" width="580px" :before-close="dialogBeforeClose">
      <div style="width: 100%;">
        <el-form ref="formRef" :model="groupForm" label-width="120px">
            <el-form-item label="当前组别：">
              <span class="no-br" style="margin-right:0"> {{orderGroupObj.startDate}} ~ {{orderGroupObj.endDate }}</span>
              <el-tag v-if='orderGroupObj.tag' size='mini' style='color:#409EFF;background-color:#ecf5ff;border-color:#d9ecff;margin-left:5px'> {{ orderGroupObj.tag }}</el-tag>
            </el-form-item>
            <el-form-item label="修改为：" prop="orderGroupCode" :rules="[{required:true,message:'请选择组别',trigger:'blur'}]">
              div.oderDiv
                el-select(v-model="groupForm.orderGroupCode"  placeholder="请选择订单组别" size='small' style='width:360px;position:reva' value-key='uuid' ref="groupSelectRef" @visible-change='handleVisibleChange')
                    el-option(v-for="item in orderGroupList" :key="item.uuid" :label="''" :value="item")
                      div(style='display:flex;align-items:center;justify-content:space-between')
                        span {{ item.startDate+'~'+ item.endDate }}
                        el-tag(v-if='item.tag' size='mini' ) {{ item.tag }}
                div.selectText(@click="textClickSelect" v-if='currentGroup.uuid')
                  span(v-if="currentGroup.startDate") {{ currentGroup.startDate+'~'+ currentGroup.endDate }}
                  el-tag(v-if='currentGroup.tag' size='mini' style='color:#409EFF;background-color:#ecf5ff;border-color:#d9ecff') {{ currentGroup.tag }}
                div.selectText(@click="textClickSelect" v-else)
                  span(style="color:#979595 ") 请选择组别
            </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
          <el-button size="small" @click="dialogBeforeClose">取 消</el-button>
          <el-button size="small" style="background-color: #FF3973;color: white;"  @click="saveGroupListEvent">确 定</el-button>
      </div>
  </el-dialog>
</template>
<script>
import {jsUuid} from '@/utils/functions.js'
export default {
  watch:{
    async [`groupForm.orderGroupCode`](v, o) {
      console.log(v)
      const topGroup = v
      // let startDate = this.orderSendTimeObj.startDate
      // let endDate = this.orderSendTimeObj.endDate
      // this.isEditFlag = true
      // if (+new Date(topGroup.startDate) > +new Date(startDate) || +new Date(topGroup.endDate) < +new Date(endDate)) {
      //   let _startDate = +new Date(topGroup.startDate) > +new Date(startDate) ? startDate : topGroup.startDate
      //   let _endDate = +new Date(topGroup.endDate) < +new Date(endDate) ? endDate : topGroup.endDate
      //   await this.$confirm(`<div><div>当前组别已更新</div><div>原时间范围${topGroup.startDate}~${topGroup.endDate}调整为${_startDate}~${_endDate}</div></div>`, '温馨提示', {
      //     confirmButtonText: '确定',
      //     showCancelButton: false,
      //     showClose: false,
      //     dangerouslyUseHTMLString: true,
      //     type: 'warning'
      //   }).then(res => {
      //     this.currentGroup =  {
      //       ...topGroup,
      //       startDate: _startDate,
      //       endDate:_endDate
      //     }
      //     return true
      //   }).catch(() => {
      //     this.groupForm.orderGroupCode = {
      //       ...o
      //     }
      //   })

      // } else {
      //   this.currentGroup =  topGroup
      // }
      // let startDate = this.orderSendTimeObj.startDate
      // let endDate = this.orderSendTimeObj.endDate
      // this.isEditFlag = true
      // let _startDate = +new Date(topGroup.startDate) > +new Date(startDate) ? startDate : topGroup.startDate
      // let _endDate = +new Date(topGroup.endDate) < +new Date(endDate) ? endDate : topGroup.endDate
      this.currentGroup =  {
        ...topGroup
      }
    },
  },
  data() {
    return {
      dialogVisible: false,
      groupTableData: [],
      tableLoading:false,
      groupForm:{
        orderGroupCode:{}
      },
      currentCode:'',
      orderGroupObj:{},
      orderGroupList:[],
      currentGroup:{},
      orderSendTimeObj:{}, //  订单投放时间
      isDropdownOpen:false,
      isEditFlag:false
    }
  },
  props: {
    contractCodes: {
      type: String,
      default:''
    }
  },
  methods: {
    jsUuid,
     /**
     * @param {Date} currentDate 当前组别范围
     * @param {Date} targetDate 目标组别范围(动态)
     */
    compareTime(currentDate, targetDate) {
      const startTiemFlag = +new Date(currentDate.startDate) >= +new Date(targetDate.startDate)
      const endTiemFlag = +new Date(currentDate.endDate) <= +new Date(targetDate.endDate)
      return startTiemFlag && endTiemFlag
    },
    textClickSelect(event) {
        if (this.isDropdownOpen) {

          this.$refs.groupSelectRef.blur()
          this.isDropdownOpen = false
        } else {
          this.$refs.groupSelectRef.focus()
          this.isDropdownOpen = true
          // this.$refs.groupSelectRef.visible = true
          this.$set(this.$refs.groupSelectRef,'visible',true)
        }
    },
    // 监听下拉框状态变化
    handleVisibleChange(visible) {
      this.isDropdownOpen = visible
    },
    dialogBeforeClose() {
      this.dialogVisible = false
      this.isEditFlag = false
      this.groupForm.orderGroupCode = {}
      this.groupTableData = []
    },
    // 保存组别
    saveGroupListEvent() {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // if(this.currentCode && this.currentCode === this.currentGroup.uuid) return this.$message.warning('当前组别一致无需更改')
          this.saveGroupList()
        }
      })

    },
    async saveGroupList() {
      let orderGroups = []
      const {startDate,endDate,uuid} = this.currentGroup
      // this.orderGroupList.forEach(s =>{
      //   if(s.code === code){
      //     s.startDate = startDate
      //     s.endDate = endDate
      //   }
      // })
      const flag = this.compareTime(this.orderSendTimeObj, { startDate, endDate })
      if (!flag) {
        let _startDate = +new Date(this.orderSendTimeObj.startDate) > +new Date(startDate) ? startDate : this.orderSendTimeObj.startDate
        let _endDate = +new Date(this.orderSendTimeObj.endDate) < +new Date(endDate) ? endDate : this.orderSendTimeObj.endDate
        const confirm = await this.$confirm(`<div><div>是否确认更新当前组别</div><div>原时间范围${startDate}~${endDate}调整为${_startDate}~${_endDate}</div></div>`, '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString: true,
          type: 'warning'
        }).then(res => {
          return true
        }).catch(err => {
          return false
        })
        if (confirm) {

          orderGroups = this.orderGroupList.map(s => {
            if (s.uuid === uuid) {
              return {
                ...s,
                startDate:_startDate,
                endDate:_endDate
              }
            } else {
              return {...s}
            }
          })
        } else {
          return
        }
      } else {
        orderGroups = this.orderGroupList
      }
      const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups', {
        orderGroups
      }, 'post')
      if (result.code === 0) {
        this.$message.success('订单组别编辑成功')
        this.dialogBeforeClose()
        this.$emit('confirmGroup',this.orderGroupList.length?this.currentGroup.code:result.data[0].code)
      }
    },
    showVisiable(param) {
      console.log(param)
      this.dialogVisible = true
      this.orderSendTimeObj = param.orderSendTimeObj
      this.orderGroupObj = param.orderGroupObj
      this.orderGroupList = param.groupList
      this.currentCode = param.orderGroupCode
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-date-editor{
  border: 1px solid #DCDFE6;
}
::v-deep .el-dialog__body{
  padding: 15px 20px;
}
::v-deep .cloumnBtn{

  margin-left: 0;
  padding: 8px 12px;
}
::v-deep .cloumnBtn  i{
  font-size: 20px;

}
.tagText{
  background-color: #ecf5ff;
  border-color: #d9ecff;
  display: inline-block;
  height: 32px;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  color: #409EFF;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  box-sizing: border-box;
  white-space: nowrap;
}
.oderDiv{
  position: relative;
}
.selectText{
  pointer-events: none;
  position: absolute;
  width: 345px;
  height: 28px;
  line-height: 28px;
  padding-left: 10px;
  background-color: white;
  top: 6px;
  left: 2px;
  z-index: 999;
  span{
    margin-left: 5px;
  }
}
</style>
